exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_object-pie.js
// module id = Pe4C
// module chunks = 0